// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"255e17af","220":"bc7daeeb","225":"728680ac"}[chunkId] + ".chunk.js";
};